<template>
    <div class="md-house-facts broker" :style="{ marginBottom, paddingTop }">
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
            noPadding
            noMargin
            v-if="exist"
        >
            <div class="title">
                <h2 class="mg-title">{{ cmpTitle }}</h2>
            </div>
            <div class="content-box">
                <div
                    class="content"
                    v-for="(item, index) in facts"
                    :key="index"
                >
                    <div class="fact-box">
                        <div
                            class="icon iconfont"
                            :class="[item.iconClass, 'icon-' + index]"
                        ></div>
                        <div class="express-content">
                            <p class="number" :class="item.numberClass">
                                <i
                                    class="iconfont"
                                    :class="item.trend"
                                    v-if="item.trend"
                                ></i
                                ><span>{{ item.number }}</span
                                ><span v-if="item.trend" class="percent"
                                >%</span
                                >
                            </p>
                            <p class="expressText">{{ item.expressText }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer">
                <div class="tip">{{ cmpTip }}</div>
                <button
                    class="bt-contact"
                    @click="handleContact($event, 'broker')"
                >
                    {{ cmpContactBTText }}
                </button>
            </div>
        </module-box>
    </div>
</template>

<script>
import common from '../index';
export default {
    mixins: [common],
    computed: {
        cmpTip() {
            return (
                this.tip ||
                this.$t('md-house-facts.doYouWantToGetAnExclusiveSellPlan')
            );
        }
    }
};
</script>

<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';

.md-house-facts.broker {
    .mg-container {
        overflow: visible;
    }
    .content-box {
        margin: 0 0 25px 0;
        position: relative;
        left: 50%;
        transform: translate(-50%, 0);
        .content {
            display: inline-block;
            margin: 0 10px;
            width: 320px;
            height: 180px;
            border-radius: 4px;
            background: #f7f7f7;
            border-top: 6px solid var(--color-theme);
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
            &:nth-child(1) {
                margin-left: 0;
            }
            &:last-child {
                margin-right: 0;
            }
            .fact-box {
                height: 100%;
                display: flex;
                flex-direction: row;
                align-items: center;
                --height: 60px;
                .icon {
                    flex: 1;
                    text-align: center;
                    flex-basis: var(--height);
                    font-size: 32px;
                    line-height: var(--height);
                    &::before {
                        border-radius: var(--height);
                        display: inline-block;
                        height: var(--height);
                        width: var(--height);
                        border: solid 1px #dadada;
                    }
                    &.icon-v3-Increase::before {
                        color: #1774f1;
                    }
                    &.icon-v3-Days::before {
                        color: #5452ce;
                    }
                    &.icon-v3-NeighborhoodPrice::before {
                        color: #17b124;
                    }
                }
                .green {
                    color: #29cb90;
                }
                .red {
                    color: #ff4444;
                }
                p.number {
                    font-size: 36px;
                    height: 30px;
                    line-height: 30px;
                    margin-bottom: 20px;
                    font-family: var(--font-bold);
                    span.percent {
                        font-size: 18px;
                    }
                    .iconfont {
                        margin-right: 5px;
                        display: inline-block;
                        transform: translateY(-2px);
                    }
                }
                .express-content {
                    flex: 5;
                    height: 80px;
                    .expressText {
                        height: 30px;
                        line-height: 18px;
                        color: #191919;
                        font-size: 14px;
                    }
                }
            }
        }
    }
    .footer {
        width: 100%;
        text-align: center;
        .tip {
            color: #505050;
            font-size: 12px;
            text-align: center;
            line-height: 1.67;
        }
        .bt-contact {
            margin-top: 12px;
            text-align: center;
            text-transform: uppercase;
            cursor: pointer;
            font-family: var(--font-bold);
            font-size: 16px;
            border-radius: 5px;
            padding: 10px 20px;
            min-width: 195px;
            @include color-button();
        }
    }
    @include media-600 {
        .mg-container {
            overflow: visible;
        }
        .content-box {
            height: unset;
            flex-direction: column;
            margin: 0;
            .content {
                height: 130px;
                margin: 0 0 15px 0;
                max-width: unset;
                width: 100%;
                .fact-box {
                    .express-content {
                        height: unset;
                        .expressText {
                            height: unset;
                        }
                    }
                    p.number {
                        font-size: 28px;
                        margin-bottom: 12px;
                    }
                }
            }
        }
        .footer {
            padding: 0 22px;
            .bt-contact {
                font-family: var(--font-normal);
                font-size: 16px;
                border-radius: 5px;
                color: var(--color-theme);
                background-color: #ffffff;
                padding: 10px 20px;
                max-width: 100%;
                border: solid 1px var(--color-theme);
            }
        }
        .title {
            .tip {
                display: block;
            }
        }
    }
}
</style>
